import axios from 'api';

export const getFeaturesPageData = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/features/front_end_page/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateFeaturePage = (params) => {
  return axios.put(`api/features/front_end_page/${params.id}/`, params);
};

export const getAllRolesData = () => {
  return axios.get(`api/core/groups/?get_all=true`);
};

export const getPageComponentData = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/features/front_end_page_component/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const getAllPages = () => {
  return axios.get(`api/features/front_end_page/?get_all=true`);
};

export const updatePageComponent = (params) => {
  return axios.put(`api/features/front_end_page_component/${params.id}/`, params);
};

export const getComponentFeaturesData = ({ search, pageSize, pageIndex, pageFilter, pageComponentFilter, metaDataFilter }) => {
  return axios.get(
    `api/features/front_end_page_component_feature/?search=${search}&page=${pageIndex}&page_size=${pageSize}&page__id=${pageFilter}&frontend_page_component__id=${pageComponentFilter}&meta_data_field__id=${metaDataFilter}`
  );
};

export const getAllPageComponents = () => {
  return axios.get(`api/features/front_end_page_component/?get_all=true`);
};

export const getAllMetaDataFields = () => {
  return axios.get(`api/customer_meta_data/customer_meta_data/?get_all=true`);
};

export const updateComponentFeature = (params) => {
  return axios.put(`api/features/front_end_page_component_feature/${params.id}/`, params);
};

export const createComponentFeature = (params) => {
  return axios.post(`api/features/front_end_page_component_feature/`, params);
};

export const deleteComponentFeature = (id) => {
  return axios.delete(`api/features/front_end_page_component_feature/${id}`);
};
